/**
 * Image URLs from the backend's stored paths (docs/legacy-audit/API.md §1.14):
 *   `/uploads/...`, `/static/experiences/...`   served from the API origin (dev: proxied)
 *   `https://...`                               used as is
 *   bare file names                             under `/api/uploads/<folder>/`
 * A vehicle without a photo gets a neutral silhouette instead of a broken image.
 */

/** Neutral car silhouette (transparent background, like the cut-out photos). */
export const VEHICLE_PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 240"><g fill="#C9D3CD">' +
      '<path d="M70 150c0-14 8-24 22-28l52-14 42-36c10-9 23-14 37-14h86c14 0 26 5 36 14l40 36 30 6c18 4 31 18 31 36v18c0 8-6 14-14 14h-22a44 44 0 0 0-86 0H178a44 44 0 0 0-86 0H84c-8 0-14-6-14-14z"/>' +
      '<circle cx="135" cy="190" r="30"/><circle cx="351" cy="190" r="30"/></g>' +
      '<g fill="#F4F7F5"><path d="M196 84c6-6 14-9 22-9h40v39h-90zM272 75h30c9 0 17 3 23 9l26 30h-79z"/>' +
      '<circle cx="135" cy="190" r="12"/><circle cx="351" cy="190" r="12"/></g></svg>',
  );

export function assetUrl(baseUrl: string, stored: unknown, folder = ''): string {
  if (typeof stored !== 'string' || !stored.trim()) return '';
  const s = stored.trim();
  if (/^(https?:)?\/\//i.test(s) || s.startsWith('data:') || s.startsWith('blob:')) return s;
  const base = baseUrl.replace(/\/$/, '');
  if (s.startsWith('/')) return `${base}${s}`;
  if (s.startsWith('uploads/') || s.startsWith('static/')) return `${base}/${s}`;
  return `${base}/api/uploads/${folder ? `${folder.replace(/\/$/, '')}/` : ''}${s}`;
}

/** First usable image of a list of stored paths or `{ url }` objects. */
export function firstImage(baseUrl: string, images: unknown): string {
  if (!Array.isArray(images)) return '';
  for (const img of images) {
    const url = assetUrl(baseUrl, typeof img === 'string' ? img : (img as { url?: unknown } | null)?.url);
    if (url) return url;
  }
  return '';
}
